import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Import Components
import Header from './components/Header/Header';
import Navigation from './components/Navigation/Navigation';
import Footer from './components/Footer/Footer'; // 1. Import the Footer

// Import Pages
import HomePage from './pages/HomePage/HomePage';
import BioPage from './pages/BioPage/BioPage';
import MusicPage from './pages/MusicPage/MusicPage';
import TestimonialsPage from './pages/TestimonialsPage/TestimonialsPage';
import ContactPage from './pages/ContactPage/ContactPage';


function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main className="content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/bio" element={<BioPage />} />
            <Route path="/music" element={<MusicPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer /> {/* 2. Add the Footer component here */}
      </div>
    </Router>
  );
}

export default App;